import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import Tag from './Tag.js';
import { jsx } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';
import Icon from '../Icon/Icon.js';
import { ICON_UI_CLOSE } from '../../icons/ICON_UI_CLOSE.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FilterTag = function FilterTag(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var isGlobetrotter = useIsGlobetrotter();
  var filterTagVariant = isGlobetrotter ? 'quartz' : 'black';
  return /*#__PURE__*/jsx(Tag, _objectSpread(_objectSpread({}, rest), {}, {
    variant: filterTagVariant,
    iconAfter: /*#__PURE__*/jsx(Icon, {
      path: ICON_UI_CLOSE
    }),
    $filterTag: true
  }));
};
var FilterTag$1 = FilterTag;

export { FilterTag$1 as default };
//# sourceMappingURL=FilterTag.js.map
